import { render, staticRenderFns } from "./article_index.vue?vue&type=template&id=118aa594&scoped=true"
import script from "./article_index.vue?vue&type=script&lang=js"
export * from "./article_index.vue?vue&type=script&lang=js"
import style0 from "./article_index.vue?vue&type=style&index=0&id=118aa594&prod&scoped=true&lang=css"
import style1 from "./article_index.vue?vue&type=style&index=1&id=118aa594&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118aa594",
  null
  
)

export default component.exports